import {Component, OnDestroy, OnInit} from '@angular/core';
import {DeleteButtonComponent} from "../../../core/delete-button/delete-button.component";
import {ManageButtonComponent} from "../../../core/manage-button/manage-button.component";
import {PreviewButtonComponent} from "../../../core/preview-button/preview-button.component";
import {QuickDashboardComponent} from "../../../core/quick-dashboard/quick-dashboard.component";
import {interval, Observable, Subscription} from "rxjs";
import {ApiService, RagSessionDef, RagTemplateDef} from "../../../services/api.service";
import {RouterLink} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";
import {UserIdTagComponent} from "../../users/user-id-tag/user-id-tag.component";
import {RequireClaimsDirective} from "../../../auth/components/require-claims.directive";
import {UptimeViewComponent} from "../../../core/uptime-view/uptime-view.component";
import {NgClass, NgIf} from "@angular/common";
import {AuthService} from "../../../auth/services/auth.service";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
  selector: 'sessions-list',
  standalone: true,
  imports: [
    DeleteButtonComponent,
    ManageButtonComponent,
    PreviewButtonComponent,
    QuickDashboardComponent,
    RouterLink,
    MatIconModule,
    UserIdTagComponent,
    RequireClaimsDirective,
    UptimeViewComponent,
    NgIf,
    MatTooltipModule,
    NgClass
  ],
  templateUrl: './sessions-list.component.html'
})
export class SessionsListComponent implements OnInit, OnDestroy {

  loader?: Observable<RagSessionDef[]>
  timerSub?: Subscription
  now = new Date()
  isExtendedView = false

  constructor(
    readonly api: ApiService,
    readonly auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.reload('ngOnInit')
    this.timerSub = interval(1000).subscribe({
      next:() => {
        this.now = new Date()
      }
    })
    this.isExtendedView = this.auth.hasRoleInRange(['Super', 'Admin'])
      || this.auth.hasClaim('system', true)
  }

  reload(reason: string) {
    this.loader = this.api.getSessions()
  }

  ngOnDestroy(): void {
    this.timerSub?.unsubscribe()
    this.timerSub = undefined
  }
}
